module.exports = __webpack_public_path__ + "static/assets/ffab9ca530e3a5f128258d580eaf19f4.svg";